import React, { useEffect, useState } from "react";
import Modal from "@mui/material/Modal";
import { TextField } from "@mui/material";
import { RxCross1 } from "react-icons/rx";

const EditPlantMappingModal = ({
  open,
  onClose,
  data,
  onSubmit,
  saving = false,
}) => {
  const [cloneId, setCloneId] = useState("");

  useEffect(() => {
    if (open && data) {
      setCloneId(data.clone_id || "");
    }
  }, [open, data]);

  return (
    <Modal open={open} onClose={onClose}>
      <div className="modal_block" style={{ maxWidth: 520, width: "90vw" }}>
        <div className="modal_header">
          <div className="modal_title_wrapper">
            <h2 className="modal_title">Edit Plant Mapping</h2>
          </div>
          <div className="cancel-btn-wrap">
            <RxCross1 onClick={onClose} />
          </div>
        </div>

        <div className="modal_content">
          <div className="form_field_wrapper">
            <label>Epicenter</label>
            <TextField
              fullWidth
              size="small"
              value={data?.epicenter || ""}
              disabled
            />
          </div>

          <div className="form_field_wrapper">
            <label>Bucket ID</label>
            <TextField
              fullWidth
              size="small"
              value={data?.bucket_id || ""}
              disabled
            />
          </div>

          <div className="form_field_wrapper">
            <label>METRC ID</label>
            <TextField
              fullWidth
              size="small"
              value={data?.metrc_id || ""}
              disabled
            />
          </div>

          <div className="form_field_wrapper">
            <label>Clone ID</label>
            <TextField
              fullWidth
              size="small"
              value={cloneId}
              onChange={(e) => setCloneId(e.target.value)}
            />
          </div>
        </div>

        <div className="modal_footer">
          <button onClick={onClose} className="btn btn-border">
            Cancel
          </button>
          <button
            onClick={() => onSubmit({ clone_id: cloneId })}
            className="btn btn-primary"
            disabled={saving}
          >
            Save
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default EditPlantMappingModal;
